import React, { useState } from 'react';
import { Card, CardContent, Radio } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Button, ButtonSize, ButtonWidth, Theme } from '../../components';
import { AccountType } from '../../../sdk/type';
import amwayLogo from '../../../assets/image/Amw_Logo_Black.webp';
import './style.scss';
// import ProfileInfo from '../profileInfo';

interface AccountSelectionProps {
  accounts: AccountType[];
  login: (account?: AccountType) => void;
}

const AccountSelection: React.FC<AccountSelectionProps> = ({
  accounts,
  login,
  // handleShowProfileInfo,
  // handleProfileInfoChange,
  // showProfileInfoDrawer,
  // profileInfo,
}) => {
  const [selectedValue, setSelectedValue] = useState(0);

  const { t } = useTranslation();

  const handleOnContinue = async () => {
    await login(accounts?.[selectedValue]);
  };

  const handleChange = (value: number) => {
    setSelectedValue(value);
  };

  return (
    <main className="acc-select">
      <header className="acc-select__header">
        <img src={amwayLogo} alt="amway-logo" height={30} />
      </header>
      <section className="acc-select__content">
        <Card className="acc-select__content-card">
          <div className="acc-select__content-card-header">
            <h1>{`${t('dashboard.accountSelection.label.selectProfile')}:`}</h1>
            <p>{`${t('dashboard.accountSelection.label.multipleAccSelectionDesc')}:`}</p>
          </div>
          <CardContent>
            {accounts.map((acc, idx) => (
              <div key={idx} className="acc-select__content-card-item" onClick={() => handleChange(idx)}>
                <Radio
                  className="acc-select__radio"
                  checked={selectedValue === idx}
                  value={idx}
                  onChange={() => handleChange(idx)}
                  inputProps={{ 'aria-label': `${acc?.abo_name} ${acc?.abo}` }}
                  sx={{
                    color: '#707070',
                  }}
                />
                <div>
                  <div className={`name ${selectedValue === idx ? 'selected' : ''}`}>{acc?.abo_name}</div>
                  <div className="aboId">{acc?.abo}</div>
                </div>
              </div>
            ))}
            <Button
              buttonWidth={ButtonWidth.FULL_WIDTH}
              size={ButtonSize.MEDIUM}
              theme={Theme.BLACK}
              title={t('dashboard.accountSelection.button.continue')}
              onClick={() => handleOnContinue()}
              className="acc-select__content-btn"
            />
          </CardContent>
        </Card>
      </section>
      {/* <ProfileInfo
        showProfileInfoDrawer={showProfileInfoDrawer}
        login={() => login(accounts?.[selectedValue], profileInfo?.name, profileInfo?.email)}
        onChange={handleProfileInfoChange}
      /> */}
    </main>
  );
};

export default AccountSelection;
